<template>
  <main>
    <div class="screen">
      <div class="from">van {{ originName }} naar</div>
      <ul>
        <li
          v-for="destination in origin.destinations"
          :key="destination.uid"
          @click="handleRowClick(destination)"
        >
          {{ destination.name }}
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      originName: false
    }
  },
  computed: {
    ...mapState({
      origin (state) {
        if (!state.stops) {
          return false
        }

        return state.stops.filter(stop => {
          return stop.name == this.originName
        })[0]
      }
    })
  },
  methods: {
    continueIfSingleDestination () {
      if (this.origin.destinations && this.origin.destinations.length === 1) {
        if (this.$route.query.history === 'back') {
          return this.$router.push(`/stops`)
        }

        const destination = this.origin.destinations[0]
        return this.$router.push(`/stops/${this.origin.name}/${destination.name}`)
      }
    },
    handleRowClick (destination) {
      this.$router.push(`/stops/${this.origin.name}/${destination.name}`)
    }
  },
  created() {
    this.$store.commit('SET_BACK_BUTTON', '/')
    this.originName = this.$route.params.origin
    this.continueIfSingleDestination()
  }
}
</script>

<style lang="scss" scoped>
.from {
  margin-bottom: 15px;
  font-size: 15px;
  color: #fff;
  letter-spacing: 0.58px;
  text-align: center;
}

ul {
  float: left;
  width: 100%;
  list-style: none;
  padding: 0 30px 44px;
  margin: 0;
}

ul li {
  float: left;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px 0;
  background: #70CCFF;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.5px;
  line-height: 25px;
  color: #fff;
  border-radius: 5px;
}
ul li:nth-child(even) {
  margin-bottom: 10px;
}
</style>
